module.exports = __webpack_public_path__ + "img/auslagern.369ac0b6.svg";